module.exports = __webpack_public_path__ + "assets/ee29295551f9e97d8a083616451d97f3.png";